import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateResolvedStepMigrationRequest = {
    resolvedSteps: '_resolvedStep',
};
var _bulkCreateResolvedStepMigrationResponse = {
    results: '_bulkResolvedStepResult',
};
var _bulkResolvedStepResult = { item: '_resolvedStep' };
var _getResolvedStepRequest = {};
var _getResolvedStepResponse = { resolvedStep: '_resolvedStep' };
var _listResolvedStepsRequest = {};
var _listResolvedStepsResponse = { resolvedSteps: '_resolvedStep' };
var _queryResolvedStepsRequest = {};
var _queryResolvedStepsResponse = { resolvedSteps: '_resolvedStep' };
var _resolvedStep = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _resolveSectionStepMigrationRequest = {};
var _resolveSectionStepMigrationResponse = { items: '_resolvedStep' };
var _resolveStepRequest = {};
var _resolveStepResponse = { resolvedStep: '_resolvedStep' };
var _undoStepRequest = {};
var _undoStepResponse = {};
function resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Resolve program step */
export function resolveStep(payload) {
    var _a = serializer(_resolveStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveStepResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __resolveStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.ResolveStep',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}/resolve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveStep.fromReq = fromReq;
    __resolveStep.__isAmbassador = true;
    return __resolveStep;
}
/** Undo resolved step */
export function undoStep(payload) {
    var _a = serializer(_undoStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_undoStepResponse, {}).fromJSON;
    function __undoStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.UndoStep',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}/undo',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __undoStep.fromReq = fromReq;
    __undoStep.__isAmbassador = true;
    return __undoStep;
}
/** List resolved steps by participant */
export function listResolvedSteps(payload) {
    var _a = serializer(_listResolvedStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listResolvedStepsResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __listResolvedSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.ListResolvedSteps',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listResolvedSteps.fromReq = fromReq;
    __listResolvedSteps.__isAmbassador = true;
    return __listResolvedSteps;
}
/** Get resolved steps */
export function getResolvedStep(payload) {
    var _a = serializer(_getResolvedStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getResolvedStepResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __getResolvedStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.GetResolvedStep',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getResolvedStep.fromReq = fromReq;
    __getResolvedStep.__isAmbassador = true;
    return __getResolvedStep;
}
/** Query resolved steps */
export function queryResolvedSteps(payload) {
    var _a = serializer(_queryResolvedStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryResolvedStepsResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __queryResolvedSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.QueryResolvedSteps',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/steps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryResolvedSteps.fromReq = fromReq;
    __queryResolvedSteps.__isAmbassador = true;
    return __queryResolvedSteps;
}
/** Create resolved steps in batches, needed for migration of participant steps from v1 */
export function bulkCreateResolvedStepMigration(payload) {
    var _a = serializer(_bulkCreateResolvedStepMigrationRequest, { _resolvedStep: _resolvedStep }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateResolvedStepMigrationResponse, { _bulkResolvedStepResult: _bulkResolvedStepResult, _resolvedStep: _resolvedStep }).fromJSON;
    function __bulkCreateResolvedStepMigration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.BulkCreateResolvedStepMigration',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/bulk/steps/create/migration',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateResolvedStepMigration.fromReq = fromReq;
    __bulkCreateResolvedStepMigration.__isAmbassador = true;
    return __bulkCreateResolvedStepMigration;
}
/** mark new created steps with section content resolved */
export function resolveSectionStepMigration(payload) {
    var _a = serializer(_resolveSectionStepMigrationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveSectionStepMigrationResponse, { _resolvedStep: _resolvedStep }).fromJSON;
    function __resolveSectionStepMigration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.resolved_step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.ResolveSectionStepMigration',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/resolve-section-step-migration',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveSectionStepMigration.fromReq = fromReq;
    __resolveSectionStepMigration.__isAmbassador = true;
    return __resolveSectionStepMigration;
}
//# sourceMappingURL=http.impl.js.map